import { render, staticRenderFns } from "./ListClaimCourier.vue?vue&type=template&id=96adba48"
import script from "./ListClaimCourier.vue?vue&type=script&lang=js"
export * from "./ListClaimCourier.vue?vue&type=script&lang=js"
import style0 from "./ListClaimCourier.vue?vue&type=style&index=0&id=96adba48&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports